// extracted by mini-css-extract-plugin
module.exports = {"txt":"BtnSet_txt__PXdei","radio":"BtnSet_radio__2hGZQ"};